"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Dropdown = _interopRequireDefault(require("../../../Dropdown"));
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
var _ToggleButtonsGroup = _interopRequireDefault(require("../../../ToggleButtonsGroup"));
var _States = _interopRequireDefault(require("../../../Dialer/States"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
var _PhoneMonitoring = _interopRequireDefault(require("../PhoneMonitoring"));
var _dialer = require("../../../../icons-react/dialer");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledContent = _Dropdown["default"].StyledContent,
  StyledDropdownIcon = _Dropdown["default"].StyledDropdownIcon;
var StyledTransferIcon = (0, _styledComponents["default"])(_dialer.Transfer).withConfig({
  displayName: "OperatorsDropdown__StyledTransferIcon",
  componentId: "sc-10shmcn-0"
})(["width:23px;height:19px;path{stroke:white;}"]);
var DEFAULT_PLACEHOLDER = 'Сотрудники';
var FILTER_BUTTONS = [{
  title: 'Все',
  value: 'all'
}, {
  title: 'Только онлайн',
  value: 'online'
}, {
  title: 'Только операторы',
  value: 'operators'
}];
var OperatorsDropdown = /*#__PURE__*/function (_React$PureComponent) {
  function OperatorsDropdown(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, OperatorsDropdown);
    _this = _callSuper(this, OperatorsDropdown, [props]);
    _this.state = {
      searchQuery: '',
      visibleOnly: ['all'],
      isOpen: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleFilterChange = _this.handleFilterChange.bind(_this);
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.inputRenderer = _this.inputRenderer.bind(_this);
    _this.labelRenderer = _this.labelRenderer.bind(_this);
    _this.operatorsRenderer = _this.operatorsRenderer.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(OperatorsDropdown, _React$PureComponent);
  return (0, _createClass2["default"])(OperatorsDropdown, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var target = _ref.target;
      var value = target.value;
      this.setState({
        searchQuery: value
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(ev) {
      var isOpen = this.state.isOpen;
      if (isOpen) {
        ev.stopPropagation();
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick() {
      var isOpen = this.state.isOpen;
      if (isOpen) {
        this.handleToggle();
      }
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange(_ref2) {
      var detail = _ref2.detail;
      var visibleOnly = detail.value;
      this.setState({
        visibleOnly: visibleOnly
      });
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      var _this2 = this;
      var onToggle = this.props.onToggle;
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen,
          searchQuery: '',
          visibleOnly: ['all']
        };
      }, function () {
        var isOpen = _this2.state.isOpen;
        onToggle({
          isOpen: isOpen
        });
      });
    }
  }, {
    key: "inputRenderer",
    value: function inputRenderer() {
      var searchQuery = this.state.searchQuery;
      var placeholder = this.props.placeholder;
      return /*#__PURE__*/_react["default"].createElement(StyledInput, {
        value: searchQuery,
        placeholder: placeholder,
        onClick: this.handleFocus,
        onChange: this.handleChange
      });
    }
  }, {
    key: "labelRenderer",
    value: function labelRenderer() {
      var state = this.props.state;
      var isService = state === _States["default"].IN_SERVICE;
      if (isService) {
        return /*#__PURE__*/_react["default"].createElement(StyledTransferContainer, null, /*#__PURE__*/_react["default"].createElement(StyledTransferIcon, null), this.inputRenderer());
      }
      return this.inputRenderer();
    }
  }, {
    key: "filterRenderer",
    value: function filterRenderer() {
      var visibleOnly = this.state.visibleOnly;
      return /*#__PURE__*/_react["default"].createElement(StyledToggleButtonsGroup, {
        required: true,
        key: visibleOnly[0],
        onChange: this.handleFilterChange,
        values: visibleOnly
      }, FILTER_BUTTONS.map(function (_ref3) {
        var title = _ref3.title,
          value = _ref3.value;
        return /*#__PURE__*/_react["default"].createElement(StyledButton, {
          key: value,
          value: value
        }, title);
      }));
    }
  }, {
    key: "operatorsRenderer",
    value: function operatorsRenderer() {
      var _this$props = this.props,
        operators = _this$props.operators,
        onCall = _this$props.onCall,
        onTransfer = _this$props.onTransfer,
        onListen = _this$props.onListen,
        onRequestHelp = _this$props.onRequestHelp;
      var _this$state = this.state,
        searchQuery = _this$state.searchQuery,
        visibleOnly = _this$state.visibleOnly;
      if (!operators) {
        return /*#__PURE__*/_react["default"].createElement(StyledThrobber, {
          size: 16,
          color: "grey"
        });
      }
      if (operators.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(StyledEmpty, null, "\u041D\u0435\u0442 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043E\u0442\u0434\u0435\u043B\u043E\u0432!");
      }
      return /*#__PURE__*/_react["default"].createElement(StyledPopup, null, this.filterRenderer(), /*#__PURE__*/_react["default"].createElement(StyledPhoneMonitoring, {
        searchQuery: searchQuery,
        visibleOnly: visibleOnly,
        operators: operators,
        onCall: onCall,
        onTransfer: onTransfer,
        onListen: onListen,
        onRequestHelp: onRequestHelp
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, this.props, /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
        onClickOutside: this.handleOutsideClick
      }, /*#__PURE__*/_react["default"].createElement(StyledOperatorsDropdown, {
        headRenderer: this.labelRenderer(),
        contentRenderer: this.operatorsRenderer(),
        onToggle: this.handleToggle,
        open: isOpen
      })));
    }
  }]);
}(_react["default"].PureComponent);
OperatorsDropdown.propTypes = _objectSpread({
  placeholder: _propTypes["default"].string
}, _PhoneMonitoring["default"].propTypes);
OperatorsDropdown.defaultProps = _objectSpread({
  placeholder: DEFAULT_PLACEHOLDER
}, _PhoneMonitoring["default"].defaultProps);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "OperatorsDropdown__StyledContainer",
  componentId: "sc-10shmcn-1"
})(["display:flex;flex-direction:column;"]);
var StyledOperatorsDropdown = (0, _styledComponents["default"])(_Dropdown["default"]).withConfig({
  displayName: "OperatorsDropdown__StyledOperatorsDropdown",
  componentId: "sc-10shmcn-2"
})(["color:#fff;font-size:13px;line-height:normal;border-radius:4px;border:solid 1px #919499;background-color:#262729;", "{width:530px;ul{width:100%;flex-wrap:wrap;max-height:480px;overflow-y:scroll;padding-right:5px;::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background-color:#c2c5cc;border-radius:40px;}}}", "{position:absolute;top:50%;margin-top:-2px;right:10px;}"], StyledContent, StyledDropdownIcon);
var StyledPopup = _styledComponents["default"].div.withConfig({
  displayName: "OperatorsDropdown__StyledPopup",
  componentId: "sc-10shmcn-3"
})(["width:100%;display:flex;flex-direction:column;"]);
var StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "OperatorsDropdown__StyledInput",
  componentId: "sc-10shmcn-4"
})(["flex:1;width:100%;height:38px;border:none;color:white;font-size:13px;line-height:38px;font-weight:normal;background-color:#262729;padding:10px 24px 10px 8px;"]);
var StyledTransferContainer = _styledComponents["default"].div.withConfig({
  displayName: "OperatorsDropdown__StyledTransferContainer",
  componentId: "sc-10shmcn-5"
})(["color:#fff;display:flex;position:relative;align-items:center;", "{padding-left:39px;}", "{left:8px;margin-top:-9px;position:absolute;top:50%;z-index:1;}"], StyledInput, StyledTransferIcon);
var StyledThrobber = (0, _styledComponents["default"])(_Throbber["default"]).withConfig({
  displayName: "OperatorsDropdown__StyledThrobber",
  componentId: "sc-10shmcn-6"
})(["padding:35px 0;position:relative;"]);
var StyledEmpty = _styledComponents["default"].div.withConfig({
  displayName: "OperatorsDropdown__StyledEmpty",
  componentId: "sc-10shmcn-7"
})(["width:100%;color:black;font-size:14px;line-height:70px;text-align:center;"]);
var StyledPhoneMonitoring = (0, _styledComponents["default"])(_PhoneMonitoring["default"]).withConfig({
  displayName: "OperatorsDropdown__StyledPhoneMonitoring",
  componentId: "sc-10shmcn-8"
})(["color:black;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "OperatorsDropdown__StyledButton",
  componentId: "sc-10shmcn-9"
})(["font-size:14px;margin-right:10px;background-color:white;", ""], function (p) {
  return p.checked && "\n    color: white;\n    background-color: #007aff;\n\n    &:hover { color: white; }\n  ";
});
var StyledToggleButtonsGroup = (0, _styledComponents["default"])(_ToggleButtonsGroup["default"]).withConfig({
  displayName: "OperatorsDropdown__StyledToggleButtonsGroup",
  componentId: "sc-10shmcn-10"
})(["height:auto;padding:5px 8px 10px;", "{height:36px;padding:0 13px;line-height:36px;border-radius:36px;border:1px solid #007aff;}"], StyledButton);
var _default = exports["default"] = OperatorsDropdown;